import { UserRegistrationType } from '@/services/register.types';

export const getRegisterDefaultValues = (
  registrationType: UserRegistrationType,
  email = '',
) => {
  return {
    email,
    password: '',
    confirmPassword: '',
    ...(registrationType === UserRegistrationType.INVITATION && {
      phoneNumber: '',
      phoneNumber_base: '',
      phoneNumber_dialCode: '+1',
      phoneNumber_countryCode: 'US',
    }),
  };
};
